import {isbot} from 'isbot';

/**
 * @type {boolean} do we serve an SEO version for robots (googlebot?)
 **/
const renderingForRobot = window.prerenderCloudIsServerSideRendering || isbot(navigator.userAgent);

export default renderingForRobot;
